import classnames from 'classnames/bind';
import { EColors } from '@/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Divider';

type TProps = {
  color?: EColors;
};

export const Divider = ({ color = EColors.GREY_200 }: TProps) => {
  return <div className={cn(BLOCK_NAME, `${BLOCK_NAME}--${color}`)} />;
};
